// extracted by mini-css-extract-plugin
export default {"helloworld":"Home_helloworld__8wTKJ","overlay":"Home_overlay__sHPV+","popup":"Home_popup__4w8sJ","topSeparator":"Home_topSeparator__FTxVU","bookNowA":"Home_bookNowA__7AnrO"};